export default "__VITE_ASSET__BJ3uA3$w__"